import { render, staticRenderFns } from "./IntegrationModalParams.vue?vue&type=template&id=af669626"
import script from "./IntegrationModalParams.vue?vue&type=script&lang=js"
export * from "./IntegrationModalParams.vue?vue&type=script&lang=js"
import style0 from "./IntegrationModalParams.vue?vue&type=style&index=0&id=af669626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports